import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  InputNumber,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper";

const FirmTrackingFilter = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];
      if (values.transactionDateRange) {
        const [startDate, endDate] = values.transactionDateRange;

        conditions.push(
          odata.dateRange("transactionDateValue", startDate, endDate)
        );
      }
      const collectTotalQuery = odata.ConditionalRange(
        "collectTotal",
        values.collectTotal,
        values.collectTotal2
      );
      if (collectTotalQuery) conditions.push(collectTotalQuery);

      const paymentTotalQuery = odata.ConditionalRange(
        "paymentTotal",
        values.paymentTotal,
        values.paymentTotal2
      );
      if (paymentTotalQuery) conditions.push(paymentTotalQuery);

      if (values.processTypeName) {
        conditions.push(
          odata.contains("processTypeName", values.processTypeName)
        );
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionDateRange" label="İşlem Tarihi :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="processTypeName" label="İşlem Tipi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      <Select.Option key={0} value={"Tahsilat"}>
                        Tahsilat
                      </Select.Option>
                      <Select.Option key={1} value={"Ödeme"}>
                        Ödeme
                      </Select.Option>
                      <Select.Option key={2} value={"Alış Faturası"}>
                        Alış Faturası
                      </Select.Option>
                      <Select.Option key={3} value={"Satış Faturası"}>
                        Satış Faturası
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="Ödeme Tutarı :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="collectTotal">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                              placeholder="Başlangıç"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="collectTotal2">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                              placeholder="Bitiş"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="Gelen Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="paymentTotal">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                              placeholder="Başlangıç"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="paymentTotal2">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                              placeholder="Bitiş"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default FirmTrackingFilter;
